module.exports = __webpack_public_path__ + "img/1alB-xh-xhile'.a6350d25.jpg";